import { Row, Col } from "react-bootstrap";
import { API_URL } from "../App";
import VN from "../components/VN";
import { useState, useEffect, useContext } from "react";
import { UserDataContext } from "../components/UserDataContext";
import axios from "axios";
import "../components/button.css";
import Button from "@mui/material/Button";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import Alerts from "../components/Alerts";
import { apiRequest } from "../components/Config";
import { marginTop, marginBottom } from "../App";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { addDays, isAfter, format } from "date-fns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { pl } from "date-fns/locale";
import { Formik, Form as FormikForm, Field } from "formik";
import * as Yup from "yup";
import LockIcon from "@mui/icons-material/Lock";
import { useParams } from "react-router-dom";
import { registerLocale } from "react-datepicker";
import CustomTabPanel from "../components/CustomTabPanel";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

const validationSchema = Yup.object().shape({
  //company: Yup.string().required("Firma jest wymagana"),
  //fileproject: Yup.string().required("Projekt jest wymagany"),
  //filetype: Yup.string().required("Typ dokumentu jest wymagany"),
  //filecategory: Yup.string().required("Kategoria dokumentu jest wymagana"),
  //fileregister: Yup.string().required("Rejestr dokumentu jest wymagany"),
  //dateofreceipt: Yup.date().nullable().required("Data wpływu jest wymagana"),
  // dateofissue: Yup.date().nullable().required("Data wystawienia jest wymagana"),
  // datedelivery: Yup.date().nullable().required("Data dostawy jest wymagana"),
  // datepayment: Yup.date().nullable().required("Termin płatności jest wymagany"),
  // description: Yup.string().nullable(),
});

registerLocale("pl", pl);

export default function FileEdit() {
  const { userData } = useContext(UserDataContext);
  const { id } = useParams();
  const [value, setValue] = useState(0);
  const [fileData, setFileData] = useState([]);
  const [error, setError] = useState(null);
  const [text, setText] = useState("Pobieranie danych...");
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [typesAll, setTypesAll] = useState([]);
  const [categoryAll, setCategoryAll] = useState([]);
  const [registerAll, setRegisterAll] = useState([]);
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [projects, setProjects] = useState([]);
  const [filePreview, setFilePreview] = useState(null);
  const [amounts, setAmounts] = useState({
    net: "",
    vat: "",
    gross: "",
  });

  const handleAmountChange = (field, value) => {
    const numValue = parseFloat(value) || 0;
    const newAmounts = {
      ...amounts,
      [field]: numValue,
    };
    newAmounts.gross = newAmounts.net + newAmounts.vat;
    setAmounts(newAmounts);
  };

  const font = { fontSize: "0.85rem", fontFamily: "Arial" };

  const [initialFormValues, setInitialFormValues] = useState({
    company: "",
    created: "",
    datedelivery: "",
    dateofissue: "",
    dateofreceipt: "",
    datepayment: "",
    description: "",
    filecategory: "",
    filename: "",
    fileoriginal: "",
    fileproject: "",
    filetype: "",
    fileregister: "",
    gross: 0,
    ksef: "",
    net: "",
    number: "",
    remainingpaid: "",
    shared: "",
    userId: "",
    vat: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      if (!userData) return;
      try {
        const response = await apiRequest(`file/` + id, "GET");
        console.log("file data: ", response);
        if (response[0]) {
          setInitialFormValues({
            company: response[0].company || "",
            fileproject: response[0].fileproject || "",
            description: response[0].description || "",
            filetype: response[0].filetype || "",
            filecategory: response[0].filecategory || "",
            fileregister: response[0].fileregister || "",
            filename: response[0].filename || "",
            dateofreceipt: response[0].dateofreceipt || "",
            dateofissue: response[0].dateofissue || "",
            datedelivery: response[0].datedelivery || "",
            datepayment: response[0].datepayment || "",
            net: response[0].net || "",
            vat: response[0].vat || "",
            gross: response[0].gross || 0,
            remainingpaid: response[0].remainingpaid || "",
          });
          setFileData(response);
          if (response.length === 0) setText("Brak danych o dokumencie...");
        }
      } catch (error) {
        setError(error.message);
      }
    };
    if (userData && userData.userId) {
      fetchData();
    }
  }, [userData]);

  useEffect(() => {
    const fetchData = async () => {
      if (!userData) return;
      try {
        const response = await apiRequest(
          `company/` + fileData[0].company,
          "GET"
        );
        if (response.length === 0) setText("Brak danych o firmie...");
      } catch (error) {
        setError(error.message);
      }
    };
    if (userData && userData.userId) {
      fetchData();
    }
  }, [fileData]);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        setTypesAll(await apiRequest("filestypes"));
        setCategoryAll(await apiRequest("filescategory"));
        setRegisterAll(await apiRequest("filesregister"));
        setCompanies(await apiRequest("companies"));
        setProjects(await apiRequest("filesprojects"));
      } catch (error) {
        console.log(error.message);
      }
    };
    if (userData && userData.userId) fetchAll();
  }, [userData]);

  const handleDownload = async (values) => {
    console.log(
      "api: ",
      `${API_URL}/download?file=${initialFormValues.filename}`
    );
    try {
      const response = await axios.get(
        `${API_URL}/download?file=${initialFormValues.filename}`,
        {
          responseType: "blob",
          withCredentials: true,
        }
      );
      const fileURL = URL.createObjectURL(response.data);
      setFilePreview(fileURL);
    } catch (error) {
      console.error("Błąd pobierania pliku: ", error);
    }
  };

  useEffect(() => {
    if (showApiResponse) {
      const timer = setTimeout(() => {
        setShowApiResponse(false);
      }, 3000);
      return () => clearTimeout(timer); // cleanup gdy komponent się odmontuje
    }
  }, [showApiResponse]);

  const handleSubmit = async (values, { setSubmitting }) => {
    values.id = id;
    console.log("handleSubmit values", values);
    try {
      const response = await apiRequest("fileupload", "POST", values);
      console.log("uplod response: ", response);
      if (response.error_msg == 200) {
        setApiResponse({
          title: "DANE PLIKU",
          severity: "success",
          info: "Dane zostały uaktualnione.",
        });
        setShowApiResponse(true);
      }
    } catch (error) {
      console.error("Błąd: ", error.status);
      setApiResponse({
        title: "Informacja",
        severity: "warning",
        info: "Nieznany błąd podczas aktualizacji pliku. Zgłoś problem Administratorowi.",
      });
      setShowApiResponse(true);
    } finally {
      setSubmitting(false);
    }
    setSubmitting(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    console.log("amount: ", event);
    //localStorage.setItem("selectedTabDocs", newValue);
  };
  return (
    <div>
      <VN userData={userData} />
      <ThemeProvider theme={theme}>
        {showApiResponse && (
          <Row>
            <Alerts data={apiResponse} />
          </Row>
        )}
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="underMenu"
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
        >
          <Tab label="Edycja dokumentu" />
          <Tab label="Historia zmian" />
        </Tabs>
        <CustomTabPanel value={value} index={0}>
          <Formik
            initialValues={initialFormValues}
            validationSchema={validationSchema}
            //validationSchema={null}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({
              isSubmitting,
              setValues,
              setFieldValue,
              values,
              handleChange,
              errors,
            }) => {
              console.log("VALUES:", values);
              values.gross = (
                parseFloat(values.net) + parseFloat(values.vat)
              ).toFixed(2);
              return (
                <FormikForm>
                  <Row style={{ marginTop }}>
                    {userData &&
                      (userData.permId === "1" || userData.permId === "3") && (
                        <Col md="9">
                          {companies.length > 0 && (
                            <Field name="company">
                              {({ field, meta }) => (
                                <FormControl fullWidth variant="standard">
                                  <InputLabel id="company-label">
                                    Firma
                                  </InputLabel>
                                  <Select
                                    {...field}
                                    labelId="company-label"
                                    value={values.company}
                                    onChange={handleChange}
                                    disabled
                                  >
                                    {companies.map((item) => (
                                      <MenuItem key={item.id} value={item.id}>
                                        {item.company}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  <LockIcon
                                    fontSize="small"
                                    color="disabled"
                                    style={{
                                      position: "absolute",
                                      right: 10,
                                      top: 0,
                                    }}
                                  />
                                </FormControl>
                              )}
                            </Field>
                          )}
                        </Col>
                      )}
                    {userData &&
                      (userData.permId === "1" || userData.permId === "3") && (
                        <Col md="3">
                          {projects.length > 0 && (
                            <Field name="fileproject">
                              {({ field, meta }) => (
                                <FormControl fullWidth>
                                  <InputLabel id="project-label">
                                    Projekt
                                  </InputLabel>
                                  <Select
                                    {...field}
                                    labelId="project-label"
                                    value={values.fileproject}
                                    variant="standard"
                                    onChange={handleChange}
                                  >
                                    {projects.map((item) => (
                                      <MenuItem key={item.id} value={item.id}>
                                        {item.project}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {meta.touched && meta.error && (
                                    <div
                                      style={{
                                        color: "red",
                                        fontSize: "0.8rem",
                                      }}
                                    >
                                      {meta.error}
                                    </div>
                                  )}
                                </FormControl>
                              )}
                            </Field>
                          )}
                        </Col>
                      )}
                  </Row>
                  <Row style={{ marginTop }}>
                    <Col md="3">
                      {typesAll.length > 0 && (
                        <Field name="filetype">
                          {({ field, meta }) => (
                            <FormControl fullWidth>
                              <InputLabel id="filetype-label">
                                Typ dokumentu
                              </InputLabel>
                              <Select
                                {...field}
                                labelId="filetype-label"
                                value={values.filetype}
                                variant="standard"
                                onChange={handleChange}
                              >
                                {typesAll.map((item) => (
                                  <MenuItem key={item.id} value={item.id}>
                                    {item.type}
                                  </MenuItem>
                                ))}
                              </Select>
                              {meta.touched && meta.error && (
                                <div
                                  style={{ color: "red", fontSize: "0.8rem" }}
                                >
                                  {meta.error}
                                </div>
                              )}
                            </FormControl>
                          )}
                        </Field>
                      )}
                    </Col>
                    <Col md="3">
                      {categoryAll.length > 0 && (
                        <Field name="filecategory">
                          {({ field, meta }) => (
                            <FormControl fullWidth>
                              <InputLabel id="docType-label">
                                Kategoria
                              </InputLabel>
                              <Select
                                {...field}
                                labelId="category-label"
                                value={values.filecategory}
                                variant="standard"
                                onChange={handleChange}
                              >
                                {categoryAll.map((item) => (
                                  <MenuItem key={item.id} value={item.id}>
                                    {item.category}
                                  </MenuItem>
                                ))}
                              </Select>
                              {meta.touched && meta.error && (
                                <div
                                  style={{ color: "red", fontSize: "0.8rem" }}
                                >
                                  {meta.error}
                                </div>
                              )}
                            </FormControl>
                          )}
                        </Field>
                      )}
                    </Col>
                    <Col md="3">
                      {registerAll.length > 0 && (
                        <Field name="fileregister">
                          {({ field, meta }) => (
                            <FormControl fullWidth>
                              <InputLabel id="register-label">
                                Rejestr
                              </InputLabel>
                              <Select
                                {...field}
                                labelId="register-label"
                                value={values.fileregister}
                                variant="standard"
                                onChange={handleChange}
                              >
                                {registerAll.map((item) => (
                                  <MenuItem key={item.id} value={item.id}>
                                    {item.register}
                                  </MenuItem>
                                ))}
                              </Select>
                              {meta.touched && meta.error && (
                                <div
                                  style={{ color: "red", fontSize: "0.8rem" }}
                                >
                                  {meta.error}
                                </div>
                              )}
                            </FormControl>
                          )}
                        </Field>
                      )}
                    </Col>
                  </Row>

                  <Row style={{ marginTop }}>
                    {[
                      "dateofreceipt",
                      "dateofissue",
                      "datedelivery",
                      "datepayment",
                    ].map((field, idx) => (
                      <Col md="3" key={field}>
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          adapterLocale={pl}
                        >
                          <DatePicker
                            label={
                              field === "dateofreceipt"
                                ? "Data wpływu"
                                : field === "dateofissue"
                                ? "Data wystawienia"
                                : field === "datedelivery"
                                ? "Data dostawy"
                                : "Termin płatności"
                            }
                            value={
                              values[field] ? new Date(values[field]) : null
                            }
                            onChange={(newValue) =>
                              setFieldValue(
                                field,
                                newValue ? format(newValue, "yyyy-MM-dd") : ""
                              )
                            }
                            minDate={addDays(new Date(), -90)}
                            format="yyyy-MM-dd"
                            slotProps={{
                              textField: {
                                variant: "standard",
                                fullWidth: true,
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Col>
                    ))}
                  </Row>
                  <Row style={{ marginTop }}>
                    <Col md="3">
                      <FormControl fullWidth>
                        <Field name="net">
                          {({ field, meta }) => (
                            <TextField
                              {...field}
                              label="Kwota netto"
                              value={values.net}
                              onChange={handleChange}
                              variant="standard"
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                              type="number"
                            />
                          )}
                        </Field>
                      </FormControl>
                    </Col>
                    <Col md="3">
                      <FormControl fullWidth>
                        <Field name="vat">
                          {({ field, meta }) => (
                            <TextField
                              {...field}
                              label="Kwota vat"
                              value={values.vat}
                              onChange={handleChange}
                              variant="standard"
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                              type="number"
                            />
                          )}
                        </Field>
                      </FormControl>
                    </Col>
                    <Col md="3">
                      <FormControl fullWidth>
                        <Field name="gross">
                          {({ field, meta }) => (
                            <TextField
                              {...field}
                              label="Kwota brutto"
                              value={values.gross}
                              variant="standard"
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                              type="number"
                              InputProps={{
                                readOnly: true,
                                endAdornment: (
                                  <LockIcon fontSize="small" color="disabled" />
                                ),
                              }}
                            />
                          )}
                        </Field>
                      </FormControl>
                    </Col>
                    <Col md="3">
                      <FormControl fullWidth>
                        <Field name="remainingpaid">
                          {({ field, meta }) => (
                            <TextField
                              {...field}
                              label="Pozostało do zapłaty"
                              value={values.remainingpaid}
                              variant="standard"
                              onChange={handleChange}
                              error={meta.touched && Boolean(meta.error)}
                              helperText={meta.touched && meta.error}
                              type="number"
                            />
                          )}
                        </Field>
                      </FormControl>
                    </Col>
                  </Row>

                  <Row style={{ marginTop }}>
                    <Col md="6">
                      <TextField
                        fullWidth
                        label="Opis dokumentu"
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginTop }}>
                    <Col md="2">
                      <Button
                        type="button"
                        variant="outlined"
                        onClick={handleDownload}
                        style={{ marginTop: "10px" }}
                      >
                        Podgląd dokumentu
                      </Button>
                    </Col>
                    <Col md="2">
                      <Button
                        type="submit"
                        variant="contained"
                        disabled={isSubmitting}
                        style={{ marginTop: "20px" }}
                      >
                        Aktualizuj
                      </Button>
                    </Col>
                  </Row>
                </FormikForm>
              );
            }}
          </Formik>
        </CustomTabPanel>
        {filePreview && (
          <div style={{ marginTop: "20px", height: "500px" }}>
            <iframe
              src={filePreview}
              title="Podgląd pliku"
              width="100%"
              height="100%"
              style={{ border: "1px solid #ccc" }}
            />
          </div>
        )}
      </ThemeProvider>
    </div>
  );
}
